/**
 * QASection 관련 스타일 상수들
 */

export const qaSectionStyles = {
  container: {
    p: 3,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#fff',
    borderRadius: 1.5,
    boxShadow: '0 0 20px rgba(0,0,0,0.05)',
    position: 'relative'
  },
  
  title: {
    mb: 2,
    fontWeight: 600,
    color: '#1976d2'
  },

  scrollContainer: {
    flex: 1, 
    minHeight: 0, 
    overflowY: 'auto', 
    display: 'flex', 
    flexDirection: 'column',
    pb: { xs: '80px', sm: 0 }
  }
};

export const guidanceStyles = {
  container: {
    mb: 3,
    p: 1.5,
    bgcolor: '#f8fafc',
    boxShadow: '0 0 10px rgba(25,118,210,0.07)',
    border: '1px solid #e3e8ef'
  },
  
  text: {
    color: '#222',
    fontSize: 15,
    lineHeight: 1.7,
    whiteSpace: 'pre-line'
  }
};

export const qaItemStyles = {
  container: {
    mb: 3,
    p: 2.5,
    bgcolor: '#f8fafc',
    borderRadius: 2,
    boxShadow: '0 0 10px rgba(25,118,210,0.07)',
    border: '1px solid #e3e8ef',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.2
  },
  
  question: {
    mb: 0.5, 
    color: '#1976d2', 
    fontWeight: 600, 
    fontSize: 15
  },
  
  loadingContainer: {
    display: 'flex', 
    alignItems: 'center', 
    minHeight: 40, 
    pl: 1
  },
  
  answerContainer: {
    flex: 1
  }
};

export const recommendedStyles = {
  container: {
    mb: 3,
    maxWidth: '85%',
    ml: 'auto'
  },
  
  title: {
    mb: 1,
    color: '#666',
    fontWeight: 500
  },
  
  questionsContainer: {
    display: 'flex', 
    flexWrap: 'wrap', 
    gap: 1.5
  },
  
  questionItem: {
    cursor: 'pointer',
    background: '#f5f7fa',
    borderRadius: 2,
    p: 1,
    maxWidth: '100%',
    fontSize: '14px',
    fontWeight: 500,
    color: '#222',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    transition: 'background 0.2s',
    '&:hover': {
      background: '#e3e8ef',
    },
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
    lineHeight: 1.6,
    mb: 0.5,
    minHeight: '40px',
    width: 'auto',
    overflow: 'hidden'
  },
  
  questionItemDisabled: {
    cursor: 'default',
    '&:hover': {
      background: '#f5f7fa',
    }
  }
};

export const inputFormStyles = {
  desktop: {
    display: { xs: 'none', sm: 'flex' },
    gap: 1,
    mt: 'auto',
    flexShrink: 0,
    pt: 2,
    bgcolor: '#fff'
  },
  
  mobile: {
    display: { xs: 'block', sm: 'none' },
    position: 'absolute',
    bottom: 15,
    left: 16,
    width: 'calc(100% - 32px)'
  },
  
  textField: {
    '& .MuiOutlinedInput-root': {
      bgcolor: '#fff',
      borderRadius: '20px',
      height: '40px',
      border: '1px solid #ccc',
      boxShadow: 'none',
      pr: 0,
      '&:hover': { bgcolor: '#fff', borderColor: '#aaa' },
      '& fieldset': { border: 'none' },
      '&.Mui-focused fieldset': { border: 'none' }
    },
    '& .MuiOutlinedInput-input': { py: 1.5, px: 2, fontSize: 14 },
    '& .MuiFormHelperText-root': { ml: 0.5, fontSize: 12 }
  },
  
  textFieldMobile: {
    '& .MuiOutlinedInput-root': {
      bgcolor: '#fff',
      borderRadius: '20px',
      height: '40px',
      border: '1px solid #ccc',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      pr: 0,
      '&:hover': { 
        bgcolor: '#fff', 
        borderColor: '#aaa',
        boxShadow: '0 6px 16px rgba(0,0,0,0.2)'
      },
      '&.Mui-focused': {
        boxShadow: '0 6px 20px rgba(25,118,210,0.3)',
        borderColor: '#1976d2'
      },
      '& fieldset': { border: 'none' }
    },
    '& .MuiOutlinedInput-input': { py: 1.5, px: 2, fontSize: 14 },
    '& .MuiFormHelperText-root': { ml: 0.5, fontSize: 12 }
  },
  
  iconButton: {
    color: '#888', 
    p: 0.7
  }
}; 